import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

import reportWebVitals from './reportWebVitals';
import { EntryProvider } from './contexts/entryContext';

import Layout from './components/layouts/Layout';
import WelcomePage from './pages/welcome.js';
import AgeVerificationPage from './pages/ageVerification.js';
import InformationPage from './pages/information.js';
import GameListPage from './pages/gameList.js';
import GameDetailPage from './pages/gameDetail.js';
import PrivacyPolicyPage from './pages/privacyPolicy.js';
import PlayPage from './pages/play.js';

import './styling/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <EntryProvider>
                <Routes>
                    <Route path='/' element={<WelcomePage />} />

                    <Route element={<Layout />}>
                        <Route path='age-verification' element={<AgeVerificationPage />} />
                        <Route path='information' element={<InformationPage />} />
                        <Route path='games' element={<GameListPage />} />
                        <Route path='game/:game' element={<GameDetailPage />} />
                        <Route path='privacy-policy' element={<PrivacyPolicyPage />} />
                    </Route>

                    <Route path='play' element={<PlayPage />} />

                    <Route path='*' element={<WelcomePage />} />
                </Routes>
            </EntryProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
